import ActionType from 'src/enums/actionType';
import apiClient from 'src/utils/apiClient';
import { useMassActionState } from '../MassActionStateContext';

export const useSelectCommercialRelaunchContent = () => {
  const [, setMassActionState] = useMassActionState();
  return async (action, message, actionTypeId) => {
    const commercialRelaunchContent = message ? JSON.parse(message.prospectingContent) : {};

    setMassActionState(prevState => ({
      ...prevState,
      commercialRelaunch: {
        ...prevState.commercialRelaunch,
        id: action.id,
        messageId: message.id ?? null,
        type: actionTypeId,
        ...commercialRelaunchContent,
        language: action.language,
      },
    }));
  };
};

export const onSaveCommercialRelaunchAction = async (
  modifiedContent,
  campaignId,
  messageId,
  actionId,
  callApi
) => {
  const {
    comment,
    date,
    defaultProspectingState,
    prospectingState,
    prospectingType,
    salePersonId,
  } = modifiedContent;

  const message = await callApi(apiClient.insertOrUpdateMessage, [
    {
      id: messageId,
      prospectingContent: JSON.stringify({
        comment,
        date,
        defaultProspectingState,
        prospectingState,
        prospectingType,
        salePersonId,
      }),
    },
  ]);
  const campaignAction = await callApi(apiClient.insertOrUpdateCampaignAction, [
    {
      id: actionId || null,
      actionTypeId: ActionType.PROSPECTING.id,
      campaignId,
      messageId: message.id,
      language: modifiedContent.language,
    },
  ]);
  return campaignAction;
};
